export enum LeagueDetailsComponentType {
  EDIT,
  ADD
}
